import { apiDate, localDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Divider,
    Dropdown,
    FormGroup,
    Input,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { PencilIcon } from '@heroicons/react/24/outline';
import { router, useForm, usePage } from '@inertiajs/react';
import { useEffect, useState } from 'react';

const reasons = [
    {
        id: 0,
        name: 'Doelgroepregister',
    },
    {
        id: 1,
        name: 'AGH/SFB',
    },
    {
        id: 2,
        name: 'Klant',
    },
    {
        id: 9,
        name: 'Onbekend',
    },
];

const CreateOrUpdateModal = ({ period, employments, baseEmployeeId }) => {
    const [open, setOpen] = useState(false);
    const { auth } = usePage().props;
    const { data, setData, post, patch, processing, errors } = useForm({});

    const confirm = useConfirmationStore(state => state.confirm);

    const dgrReason = reasons?.find(reason => reason.id === 0);

    useEffect(() => {
        setData(
            period || {
                reason: dgrReason?.id,
            }
        );
    }, [period]);

    const handleReasonChange = value => {
        setData({
            ...data,
            reason: value,
            end_date: value === 0 ? '' : data?.end_date,
        });
    };

    const handleDelete = () => {
        confirm({
            description: 'Weet u zeker dat u deze periode wilt verwijderen?',
            onConfirm: close => {
                router.delete(
                    `/customers/${auth?.user?.selected_customer_id}/employees/${baseEmployeeId}/no-risk/periods/${period.id}`,
                    {
                        onSuccess: () => {
                            close();

                            setOpen(false);
                        },
                    }
                );
            },
        });
    };

    const handleSubmit = () => {
        if (period?.id) {
            patch(
                `/customers/${auth?.user?.selected_customer_id}/employees/${baseEmployeeId}/no-risk/periods`,
                {
                    onSuccess: () => setOpen(false),
                }
            );

            return;
        }

        post(
            `/customers/${auth?.user?.selected_customer_id}/employees/${baseEmployeeId}/no-risk/periods`,
            {
                onSuccess: () => setOpen(false),
            }
        );
    };

    if (!open) {
        return (
            <Button onClick={() => setOpen(true)}>
                <PencilIcon className='size-3' />
            </Button>
        );
    }

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalHeader>No-riskpolis</ModalHeader>
            <ModalContent>
                <FormGroup>
                    <Dropdown
                        required
                        label='Type'
                        options={reasons || []}
                        placeholder={dgrReason?.name}
                        value={
                            (data?.reason == dgrReason?.id
                                ? dgrReason?.name
                                : data?.reason) || ''
                        }
                        onChange={handleReasonChange}
                        error={errors?.reason}
                    />
                </FormGroup>
                <FormGroup equal inline>
                    <Input
                        required
                        type='date'
                        label='Start no-risk'
                        value={apiDate(data?.start_date) || ''}
                        onChange={event =>
                            setData('start_date', event.target.value)
                        }
                        error={errors?.start_date}
                    />
                    <Input
                        type='date'
                        label='Einde no-risk'
                        value={apiDate(data?.end_date) || ''}
                        onChange={event =>
                            setData('end_date', event.target.value)
                        }
                        disabled={data?.reason === 0}
                        error={errors?.end_date}
                    />
                </FormGroup>

                <Divider content='Dienstverbanden' className='my-8' />

                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Datum indienst</TableHeaderCell>
                            <TableHeaderCell>Datum uitdienst</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {employments?.map(employment => (
                            <TableRow key={employment.id}>
                                <TableCell>
                                    {localDate(employment?.start_date)}
                                </TableCell>
                                <TableCell>
                                    {localDate(employment?.end_date)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </ModalContent>
            <ModalActions>
                <Button type='button' onClick={() => setOpen(false)}>
                    Annuleren
                </Button>
                {period?.id && (
                    <Button
                        type='button'
                        variant='danger'
                        onClick={handleDelete}
                    >
                        Verwijderen
                    </Button>
                )}
                <Button
                    variant='primary'
                    type='submit'
                    onClick={handleSubmit}
                    loading={processing}
                >
                    Opslaan
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default CreateOrUpdateModal;
